var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#7D8697"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9119 17.1125V18.5H9.91191V17.1125H12.1094V10.79C12.1094 10.54 12.1169 10.2825 12.1319 10.0175L10.5719 11.3225C10.4819 11.3925 10.3919 11.4375 10.3019 11.4575C10.2169 11.4725 10.1344 11.4725 10.0544 11.4575C9.97941 11.4425 9.91191 11.4175 9.85191 11.3825C9.79191 11.3425 9.74691 11.3 9.71691 11.255L9.13191 10.4525L12.4394 7.64H13.9619V17.1125H15.9119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber1);
export default __webpack_public_path__ + "static/media/number_1.24d0d70fdd740ee48408d2ebb9d892b6.svg";
export { ForwardRef as ReactComponent };